var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-layout"},[_c('BasicHeaderVue'),_c('div',{staticClass:"basic-container"},[_c('BasicAsideVue'),_c('router-view',{staticClass:"basic-main"})],1),_c('DialogSignInVue'),_c('DialogCustomerServiceVue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }